import store from '@/store/store'
import { ability } from '@/permissions/rules'

const getContract = contractId => store.dispatch('contract/getContract', { contractId })

const fetchContract = async (to, from, next) => {
  const contractId = to.params.contractId
  try {
    await getContract(contractId)
    next()
  } catch (e) {
    if (ability.can('read', 'AllContractsOfAgency')) {
      next({ name: 'agencyContracts' })
    } else {
      next({ name: 'contracts' })
    }
  }
}

export default fetchContract
